/*
 * copilot:data-changed (plan §9, DR-P8 (a)): a window event that says the
 * copilot changed something the page may show.
 *
 *   announceDataChanged({reason})    the panel: "write" after a write tool
 *                                    finished ok, "run_final" after a run
 *                                    reached final
 *   onCopilotDataChanged(handler)    a page: subscribe; returns unsubscribe
 *
 * It uses `window`, so it isn't in domain/. MicrogridsPage imports this
 * module only, never the hooks: with the flag off nothing announces, and the
 * listener costs nothing.
 *
 * A handler that throws is logged (a fixed string and the code only) and
 * never reaches window's `error` event, which index.js turns into a
 * replaced app. Neither function ever throws.
 */
import { logCopilotError } from "./domain/copilotLog";

export const COPILOT_DATA_CHANGED = "copilot:data-changed";

/** Dispatches one copilot:data-changed CustomEvent on window, with `detail`. */
export function announceDataChanged(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(COPILOT_DATA_CHANGED, { detail }));
  } catch (err) {
    logCopilotError("[copilot] announcing copilot:data-changed failed", err);
  }
}

/** Calls `handler(event)` on each copilot:data-changed. Returns the unsubscribe. */
export function onCopilotDataChanged(handler) {
  const listener = (event) => {
    try {
      handler(event);
    } catch (err) {
      logCopilotError("[copilot] a copilot:data-changed handler failed", err);
    }
  };
  window.addEventListener(COPILOT_DATA_CHANGED, listener);
  return () => window.removeEventListener(COPILOT_DATA_CHANGED, listener);
}
